import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../i18n/globalTranslations';
import { modelOf } from '../../../prop-types';
import UIStore from '../../../store/UIStore';

const TotalHeaders = {
  title: <FormattedMessage {...globalTranslations.totalPriceSentence} />,
  count: <FormattedMessage {...globalTranslations.purchaseOrderCountHeader} />,
  withVat: <FormattedMessage {...globalTranslations.purchaseWithVatHeader} />,
  withoutVat: (
    <FormattedMessage {...globalTranslations.purchaseWithoutVatHeader} />
  )
};

@observer
export class PurchaseTotal extends Component {
  renderValue = (total, withCurrency) => {
    return total.map((totalValue) => {
      const currency = withCurrency ? ' ' + totalValue.currency : '';
      return totalValue.value + currency;
    });
  };

  renderTotalHeaderCol = (label, sizes) => {
    const actualSizes = Object.assign(
      {
        xs: 4
      },
      sizes
    );
    return (
      <Col className="PurchaseTotal__total-header" {...actualSizes}>
        {label}
      </Col>
    );
  };

  render() {
    const { total } = this.props;
    const { isMobile } = this.props.uiStore;

    if (total.order_count.length === 0) {
      return null;
    }

    return (
      <div className="PurchaseTotal">
        <Row className="PurchaseTotal__row">
          {isMobile && this.renderTotalHeaderCol(TotalHeaders.title)}
          <Col xs="8" md="4">
            <div className="PurchaseTotal__total">
              <FormattedMessage {...globalTranslations.totalPriceSentence} />
            </div>
          </Col>
          {isMobile && this.renderTotalHeaderCol(TotalHeaders.count)}
          <Col xs="8" md="2">
            <div className="PurchaseTotal__totalOrderCount">
              {this.renderValue(total.order_count, false)}
            </div>
          </Col>
          {isMobile && this.renderTotalHeaderCol(TotalHeaders.withVat)}
          <Col xs="8" md="3">
            <div className="PurchaseTotal__totalWithVat">
              {this.renderValue(total.with_tax, true)}
            </div>
          </Col>
          {isMobile && this.renderTotalHeaderCol(TotalHeaders.withoutVat)}
          <Col xs="8" md="3">
            <div className="PurchaseTotal__totalWithoutVat">
              {this.renderValue(total.without_tax, true)}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

PurchaseTotal.propTypes = {
  uiStore: modelOf(UIStore).isRequired,
  total: PropTypes.object.isRequired
};

export default inject('uiStore')(PurchaseTotal);



// WEBPACK FOOTER //
// ./src/components/purchase/PurchaseTotal/index.jsx